module.exports = __webpack_public_path__ + "static/media/rnd.8ce6d26e.png";